/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__no_saved_itineraries = /** @type {(inputs: {}) => string} */ () => {
	return `Keine Route in den Favoriten gespeichert`
};

const en_bookmark__no_saved_itineraries = /** @type {(inputs: {}) => string} */ () => {
	return `No routes saved in your favourites`
};

const es_bookmark__no_saved_itineraries = /** @type {(inputs: {}) => string} */ () => {
	return `No tienes ningún itinerario en favoritos`
};

const fr_bookmark__no_saved_itineraries = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun itinéraire mis en favoris`
};

const it_bookmark__no_saved_itineraries = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun itinerario nei preferiti`
};

const nl_bookmark__no_saved_itineraries = /** @type {(inputs: {}) => string} */ () => {
	return `Geen routes toegevoegd aan favorieten`
};

const pt_bookmark__no_saved_itineraries = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhum itinerário adicionado aos favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__no_saved_itineraries = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__no_saved_itineraries(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__no_saved_itineraries", locale)
	if (locale === "de") return de_bookmark__no_saved_itineraries(inputs)
	if (locale === "en") return en_bookmark__no_saved_itineraries(inputs)
	if (locale === "es") return es_bookmark__no_saved_itineraries(inputs)
	if (locale === "fr") return fr_bookmark__no_saved_itineraries(inputs)
	if (locale === "it") return it_bookmark__no_saved_itineraries(inputs)
	if (locale === "nl") return nl_bookmark__no_saved_itineraries(inputs)
	return pt_bookmark__no_saved_itineraries(inputs)
};